export default __webpack_public_path__ + "static/media/el-logo.fadb8541.svg";